<script>
  import { Button } from "sveltestrap";
  import Cart from "../Components/Cart.svelte";
  export let cartItems;
  export let customer;
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  function clearCart() {
    dispatch("clearCart");
  }

  let result = null;
  let form_error = "Preencha todos os campos";
  let order_number = "";
  export let order_done = false;
  let order_error = false;
  let error_message = null;
  let is_loading = false;
  let photo_url =
    "https://api.whatsapp.com/send?phone=5516992975610&text=Comprovante%20de%20pagamento%20pedido%20numero%20";

  // This will upload the file after having read it
  const uploadFile = () => {
    let uploadData = new FormData();
    let inputPaymentFile = document.getElementById("paymentFile");
    uploadData.append("payment_file", inputPaymentFile.files[0]);
    uploadData.append("order", "1");

    fetch("https://httpbin.org/post", {
      // Your POST endpoint
      method: "POST",
      // headers: {
      //   // Content-Type may need to be completely **omitted**
      //   // or you may need something
      //   "Content-Type": "You will perhaps need to define a content-type here"
      // },
      body: uploadData // This is your file object
    })
      .then(
        response => response.json() // if the response is a JSON object
      )
      .then(
        success => console.log("SUCCESS", success) // Handle the success response object
      )
      .catch(
        error => console.log("ERROR", error) // Handle the error response object
      );
  };

  async function finishOrder() {
    form_error = "";
    // console.log("customer.paymentMethod", customer.paymentMethod);
    if (
      customer.name == "" ||
      customer.email == "" ||
      customer.phone == "" ||
      customer.paymentMethod == null
    ) {
      form_error =
        "Preencha seu nome, telefone, e-mail e uma forma de pagamento";
      return false;
    }
    is_loading = true;

    const res = await fetch("/envio_pedido.php", {
      method: "POST",
      body: JSON.stringify({
        customer,
        cartItems
      })
    });

    const json = await res.json();

    order_done = json.success;
    order_error = !json.success;
    is_loading = false;
    if (order_done) {
      order_number = json.order;
      photo_url += order_number;
    } else {
      error_message = json.error;
    }

    // result = JSON.stringify(json);
    // console.log("SUCCESS: ", json.success);
    // console.log("ORDER: ", json.order);
    // console.log("RESULT: ", result);
  }

  $: cTotal = cartItems.reduce((sum, curValue) => {
    return sum + curValue.price;
  }, 0);
</script>

{#if !order_done}
  <div class="container">
    <form
      action=""
      method="POST"
      target="_blank"
      novalidate
      on:submit|preventDefault={finishOrder}>
      <div class="row">
        <Cart on:clearCart={clearCart} items={cartItems} />
        <div class="col-md-8 order-md-1">
          <h4 class="mb-3">Seus Dados</h4>
          <div class="row" id="customerName">
            <div class="col-md-12 mb-3">
              <label for="firstName">
                Nome Completo
                <span class="text-muted">(Requerido)</span>
              </label>

              <input
                type="text"
                class="form-control {customer.name == '' ? 'is-invalid' : ''}"
                id="firstName"
                placeholder=""
                bind:value={customer.name}
                required />
              <div
                class="invalid-feedback"
                style={customer.name == '' ? 'display:block' : ''}>
                Nome completo é requerido.
              </div>
            </div>
          </div>
          <div class="row" id="customerPhone">
            <div class="col-md-12 mb-3">
              <label for="phone">
                Telefone
                <span class="text-muted">(Requerido)</span>
              </label>

              <input
                type="text"
                class="form-control {customer.phone == '' ? 'is-invalid' : ''}"
                id="phone"
                placeholder=""
                bind:value={customer.phone}
                required />
              <div
                class="invalid-feedback"
                style={customer.phone == '' ? 'display:block' : ''}>
                Telefone é requerido.
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="email">
              E-Mail
              <span class="text-muted">(Requerido)</span>
            </label>
            <input
              type="email"
              class="form-control{customer.name == '' ? ' is-invalid' : ''}"
              id="email"
              bind:value={customer.email}
              required
              placeholder="you@example.com"
              style={customer.email == '' ? 'display:block' : ''} />
            <div class="invalid-feedback">
              Por favor informe um e-mail válido
            </div>
          </div>

          <h4 class="mb-3">Pagamento</h4>

          <div class="d-block my-3">
            <div class="custom-control custom-radio">
              <input
                id="nubank"
                name="paymentMethod"
                type="radio"
                class="custom-control-input"
                value="nubank"
                bind:group={customer.paymentMethod}
                checked
                required />
              <label class="custom-control-label" for="nubank">Nubank</label>
            </div>
            <div class="custom-control custom-radio">
              <input
                id="picpay"
                name="paymentMethod"
                type="radio"
                value="picpay"
                class="custom-control-input"
                bind:group={customer.paymentMethod}
                required />
              <label class="custom-control-label" for="picpay">PicPay</label>
            </div>

          </div>
          {#if customer.paymentMethod == 'picpay'}
            <div class="row">
              <div class="col-md-12 mb-3">
                <label for="picpay_username">Seu usuário no PicPay</label>
                <input
                  type="text"
                  class="form-control"
                  id="picpay_username"
                  bind:value={customer.picpay_username}
                  placeholder="" />
                <small class="text-muted">
                  Username para validar o pagamento
                </small>
              </div>
            </div>
          {:else if customer.paymentMethod == 'nubank'}
            <div class="col-md-12 mb-3">
              <label for="cc-number">Link para pagamento:</label>
              O link para pagamento será disponibilizao após fechar a compra.
            </div>
          {/if}
          <hr class="mb-4" />
          {#if customer.name == '' || customer.email == '' || customer.phone == '' || customer.paymentMethod == null}
            <div class="alert alert-danger" role="alert">{form_error}</div>
          {/if}

          {#if order_error}
            <div class="alert alert-danger" role="alert">{error_message}</div>
          {/if}

          <Button
            color="success"
            outline
            class="btn-lg btn-block"
            type="submit"
            disabled={is_loading ? 'true' : ''}>
            {#if is_loading}
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true" />
            {/if}
            Fechar compra
          </Button>
        </div>
      </div>
    </form>
  </div>
{/if}

{#if order_done}
  <div class="container">
    {#if customer.paymentMethod == 'nubank'}
      <a
        class="btn btn-outline-success btn-lg"
        target="_blank"
        href="https://nubank.com.br/pagar/nbs60/lcZIE8lfld">
        <svg
          class="bi bi-box-arrow-right"
          width="1em"
          height="1em"
          viewBox="0 0 16 16"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            d="M11.646 11.354a.5.5 0 010-.708L14.293 8l-2.647-2.646a.5.5 0
            01.708-.708l3 3a.5.5 0 010 .708l-3 3a.5.5 0 01-.708 0z"
            clip-rule="evenodd" />
          <path
            fill-rule="evenodd"
            d="M4.5 8a.5.5 0 01.5-.5h9a.5.5 0 010 1H5a.5.5 0 01-.5-.5z"
            clip-rule="evenodd" />
          <path
            fill-rule="evenodd"
            d="M2 13.5A1.5 1.5 0 01.5 12V4A1.5 1.5 0 012 2.5h7A1.5 1.5 0 0110.5
            4v1.5a.5.5 0 01-1 0V4a.5.5 0 00-.5-.5H2a.5.5 0 00-.5.5v8a.5.5 0
            00.5.5h7a.5.5 0 00.5-.5v-1.5a.5.5 0 011 0V12A1.5 1.5 0 019 13.5H2z"
            clip-rule="evenodd" />
        </svg>
        Clique aqui e efetue o pagamento com o Nubank
      </a>
      <a href="https://nubank.com.br/pagar/nbs60/lcZIE8lfld">
        <img src="./img/nubank-logo.png" height="50" />
      </a>
    {/if}
    {#if customer.paymentMethod == 'picpay'}
      <a
        class="btn btn-outline-success btn-lg"
        target="_blank"
        href="https://app.picpay.com/user/caribedrinks/{cTotal}">
        <svg
          class="bi bi-box-arrow-right"
          width="1em"
          height="1em"
          viewBox="0 0 16 16"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            d="M11.646 11.354a.5.5 0 010-.708L14.293 8l-2.647-2.646a.5.5 0
            01.708-.708l3 3a.5.5 0 010 .708l-3 3a.5.5 0 01-.708 0z"
            clip-rule="evenodd" />
          <path
            fill-rule="evenodd"
            d="M4.5 8a.5.5 0 01.5-.5h9a.5.5 0 010 1H5a.5.5 0 01-.5-.5z"
            clip-rule="evenodd" />
          <path
            fill-rule="evenodd"
            d="M2 13.5A1.5 1.5 0 01.5 12V4A1.5 1.5 0 012 2.5h7A1.5 1.5 0 0110.5
            4v1.5a.5.5 0 01-1 0V4a.5.5 0 00-.5-.5H2a.5.5 0 00-.5.5v8a.5.5 0
            00.5.5h7a.5.5 0 00.5-.5v-1.5a.5.5 0 011 0V12A1.5 1.5 0 019 13.5H2z"
            clip-rule="evenodd" />
        </svg>
        Clique aqui e efetue o pagamento com o PicPay
      </a>
      <a href="https://app.picpay.com/user/caribedrinks/{cTotal}">
        <img src="./img/picpay-logo.png" height="50" />
      </a>
    {/if}
    <div class="alert alert-success" style="margin-top: 20px" role="alert">
      <h4 class="alert-heading">Pedido Efetuado</h4>
      <p>
        Agora basta você efetuar o pagamento e enviar o comprovante. Que
        enviaremos para você as apostilas
        <span class="text-danger">DIGITAIS (em PDF)</span>
        no prazo de um dia útil
        <span class="text-danger">no seu celular ou e-mail</span>
        .
        <br />
        <a class="btn btn-block btn-success" target="_blank" href={photo_url}>
          <svg
            class="bi bi-file-earmark-arrow-up"
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4 1h5v1H4a1 1 0 00-1 1v10a1 1 0 001 1h8a1 1 0 001-1V6h1v7a2 2
              0 01-2 2H4a2 2 0 01-2-2V3a2 2 0 012-2z" />
            <path d="M9 4.5V1l5 5h-3.5A1.5 1.5 0 019 4.5z" />
            <path
              fill-rule="evenodd"
              d="M5.646 8.854a.5.5 0 00.708 0L8 7.207l1.646 1.647a.5.5 0
              00.708-.708l-2-2a.5.5 0 00-.708 0l-2 2a.5.5 0 000 .708z"
              clip-rule="evenodd" />
            <path
              fill-rule="evenodd"
              d="M8 12a.5.5 0 00.5-.5v-4a.5.5 0 00-1 0v4a.5.5 0 00.5.5z"
              clip-rule="evenodd" />
          </svg>
          Enviar
        </a>
      </p>

    </div>
    <br />
    <br />
    <a
      href="http://www.caribedrinks.com.br"
      class="btn btn-outline-secondary pull-right">
      <svg
        class="bi bi-arrow-left"
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          d="M5.854 4.646a.5.5 0 010 .708L3.207 8l2.647 2.646a.5.5 0
          01-.708.708l-3-3a.5.5 0 010-.708l3-3a.5.5 0 01.708 0z"
          clip-rule="evenodd" />
        <path
          fill-rule="evenodd"
          d="M2.5 8a.5.5 0 01.5-.5h10.5a.5.5 0 010 1H3a.5.5 0 01-.5-.5z"
          clip-rule="evenodd" />
      </svg>
      Voltar
    </a>
    <!-- <div class="row" id="comprovante">
      <div class="col-md-12 mb-3">
        <label for="paymentFile">
          Comprovante de pagamento
          <span class="text-muted">(Requerido)</span>
        </label>

        <input
          type="file"
          class="form-control {customer.paymentFile == '' ? 'is-invalid' : ''}"
          id="paymentFile"
          placeholder=""
          bind:value={customer.paymentFile}
          required />
        <div
          class="invalid-feedback"
          style={customer.paymentFile == '' ? 'display:block' : ''}>
          Comprovante de pagamento é requerido.
        </div>
      </div>
      <div class="col-md-12 mb-3">
        <Button
          color="success"
          class="btn-lg btn-block"
          on:click={uploadFile}
          type="button">
          <svg
            class="bi bi-file-earmark-arrow-up"
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4 1h5v1H4a1 1 0 00-1 1v10a1 1 0 001 1h8a1 1 0 001-1V6h1v7a2 2
              0 01-2 2H4a2 2 0 01-2-2V3a2 2 0 012-2z" />
            <path d="M9 4.5V1l5 5h-3.5A1.5 1.5 0 019 4.5z" />
            <path
              fill-rule="evenodd"
              d="M5.646 8.854a.5.5 0 00.708 0L8 7.207l1.646 1.647a.5.5 0
              00.708-.708l-2-2a.5.5 0 00-.708 0l-2 2a.5.5 0 000 .708z"
              clip-rule="evenodd" />
            <path
              fill-rule="evenodd"
              d="M8 12a.5.5 0 00.5-.5v-4a.5.5 0 00-1 0v4a.5.5 0 00.5.5z"
              clip-rule="evenodd" />
          </svg>


        </Button>
      </div>
    </div> -->
  </div>
{/if}
